import React, { useEffect, useState } from "react";
import EditVisitDiv from './edit-visit-div';
import EditPriceDiv from './edit-price-div';
import QualityChecklist from './quality-checklist';

export default function EditVisitModal({editedVisitId, setEditVisitModalOpen}) {
    const [chosenWorkers, setChosenWorkers] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [paymentStatus, setPaymentStatus] = useState(false);  //следит за тем, чтобы количество введенных денежных средств соответствовало итоговой сумме
    const [visitInfo, setVisitInfo] = useState([]);
    const [servicesInfo, setServicesInfo] = useState([]);            //сюда записываем исходную инфу о сервисах
    const [goodsInfo, setGoodsInfo] = useState([]);
    const [workersInfo, setWorkersInfo] = useState([]);
    const api_url = process.env.REACT_APP_API_URL;
    const [availableWorkers, setAvailableWorkers] = useState();
    const complexName = localStorage.getItem('complex_name');

    useEffect(() => {
        async function getVisitInfo() {
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
            body: JSON.stringify({ visit_id: editedVisitId })
          };
          const visit = await (await fetch(api_url+"/api/visitInfo", requestOptions)).json();
          //console.log("Необработанные данные визита из API:", visit);
          setVisitInfo({adminId: visit.administrator_id, visitId: visit.visit_id, complexName: visit.complex_name, clientName: visit.client_name, carNumber: visit.car_number, carBrand: visit.car_brand, carCategory: visit.car_category, draft: visit.draft, totalAmount: visit.total_amount, bonusAmount: visit.bonus_amount, cardAmount: visit.card_amount, cashAmount: visit.cash_amount, agreementAmount: visit.agreement_amount, loyaltyCardAmount: visit.loyalty_card_amount, giftAmount: visit.gift_amount, chosenWorkers: visit.chosen_workers, chosenServices: visit.chosenServices, chosenGoods: visit.chosenGoods, paymentMethod: visit.payment_method, cashierName: visit.cashier, qualityControlName: visit.quality_control, quality_control_checklist: visit.quality_control_checklist, checklist_history: visit.checklist_history, is_quality_checked: visit.is_quality_checked, last_checklist_update: visit.last_checklist_update, first_interaction_date_formatted: visit.first_interaction_date_formatted, finalized_date_formatted: visit.finalized_date_formatted, acceptance_time_minutes: visit.acceptance_time_minutes, maxQcType: visit.maxQcType, visit_date: visit.visit_date, visit_duration_minutes: visit.visit_duration_minutes});
          setWorkersInfo(visit.chosen_workers);
          setServicesInfo(visit.chosen_services);
          setGoodsInfo(visit.chosen_goods);
        }
        getVisitInfo();

        async function getAvailableWorkers() {      //получаем список всех доступных сотрудников
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
            body: JSON.stringify({ complex_name: complexName, role: "car_washer" })
          };
          const availableWorkers = await (await fetch(api_url+"/api/availableWorkers", requestOptions)).json();
          setAvailableWorkers(availableWorkers.map(({worker_id, full_name, rank, phone_number, complex_name, role}) => ({workerId: worker_id, fullName: full_name, rank: rank, phoneNumber: phone_number, complexName: complex_name, role: role})));
        }
        getAvailableWorkers();
        }, []);

    return (
    <div>
    <div className='edit-visit-modal'>
    <EditVisitDiv setEditVisitModalOpen = {setEditVisitModalOpen} visitInfo = {visitInfo} setVisitInfo = {setVisitInfo} servicesInfo = {servicesInfo} setServicesInfo = {setServicesInfo} goodsInfo = {goodsInfo} setGoodsInfo = {setGoodsInfo}  workersInfo={workersInfo} availableWorkers={availableWorkers} setAvailableWorkers={setAvailableWorkers} />
    <div className='right-column'>
      <EditPriceDiv visitInfo = {visitInfo} setVisitInfo = {setVisitInfo} />
      <QualityChecklist visitInfo={visitInfo} />
    </div>
    </div>
    </div>
    )
}